/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useRef, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';
import AuthService from '../../services/AuthService';

// local imports
import GeneralNavbar from '../general/GeneralNavbar';
import Message from '../general/Message';
import ErrorBoundary from '../general/ErrorBoundary';

const ResetPassword = props => {

    // contexts
    const { theme, colors, fontFamily, fontSize, fontWeight } = useContext(ThemeContext);

    // states
    const [user, setUser] = useState({ token: "", password: "", confirmPassword: "" });
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    let timerID = useRef(null);

    useEffect(() => {
        try {
            setUser({ ...user, token: props.match.params.token });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User ResetPassword useEffect', 'Error in try catch block', err.stack);
        }
        return () => {
            clearTimeout(timerID)
        }
    }, [])

    // handle functions
    const handleChange = e => {
        try {
            setUser({ ...user, [e.target.name]: e.target.value });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User ResetPassword handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (user.password.length < 6) {
                setMessage({
                    msgBody: "Your password must be at least 6 characters",
                    msgError: true
                })
            } else if (user.password.search(/[a-zA-Z]/i) < 0) {
                setMessage({
                    msgBody: "Your password must contain at least one letter",
                    msgError: true
                })
            } else if (user.password.search(/[0-9]/) < 0) {
                setMessage({
                    msgBody: "Your password must contain at least one digit",
                    msgError: true
                })
            } else if (user.password.search(/[A-Z]/) < 0) {
                setMessage({
                    msgBody: "Your password must contain at least one uppercase letter",
                    msgError: true
                })
            } else if (user.password === user.confirmPassword) {
                setIsLoading(true);
                AuthService.resetPassword(user).then(data => {
                    setMessage(data.message);
                    setIsLoading(false);
                    timerID = setTimeout(() => {
                        props.history.push('/user/signin');
                    }, 1500);
                })
                    .catch(error => {
                        setIsLoading(false);
                        setMessage(error.message)
                    })
            } else {
                setMessage({
                    msgBody: "Passwords don't match",
                    msgError: true
                })
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at User ResetPassword handleSubmit', 'Error in try catch block', err.stack);
        }
    }


    // function's return
    return (
        <div>
            <ErrorBoundary errorAt="At User SignIn GeneralNavbar">
                <GeneralNavbar history={props.history} isSignInPage={true} />
            </ErrorBoundary>
            <div className="p-3 col-md-4 mt-5 mb-5 offset-md-4" style={theme.form}>
                <form onSubmit={handleSubmit} style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                    <h2 style={theme.heading}>Reset password</h2>
                    <br />

                    <ErrorBoundary errorAt="At User ResetPassword Message">
                        {message ? <Message message={message} /> : null}
                    </ErrorBoundary>

                    <ErrorBoundary errorAt="At User ResetPassword Fields">
                        <label htmlFor="password" style={theme.formBodyText} >New password </label>
                        <input type="password"
                            name="password"
                            value={user.password}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />

                        <label htmlFor="confirmPassword" style={theme.formBodyText} >Confirm Password </label>
                        <input type="password"
                            name="confirmPassword"
                            value={user.confirmPassword}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />

                        <p style={{ fontFamily: fontFamily.primary, fontSize: fontSize.sm }}>*Password must have at least 6 characters with one alphabet, one digit and one uppercase</p>

                        <button className="btn mt-2" type="submit" style={theme.formSubmit} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Reset password</button>
                    </ErrorBoundary>
                </form>
            </div>
        </div>
    )


}

export default ResetPassword;